export default [
    {
        path: '/:organisation/portals/team-members',
        component: () => import(/* webpackChunkName: "team-member.payslips" */ '@/layouts/PortalLayout.vue'),
        name: 'team-member-portal.start',
        meta: {
            guestRequired: false,
            loginRequired: true,
            permission: '*',
        },
        children: [
            {
                path: 'payslips',
                component: () => import(/* webpackChunkName: "team-member.payslips" */ '@/pages/[organisation]/portals/team-members/payslips/index.vue'),
                name: 'team-member-portal.payslips',
                meta: {
                    guestRequired: false,
                    loginRequired: true,
                    permission: '*',
                },
            },

            {
                path: 'payslips/:id',
                component: () => import(/* webpackChunkName: "team-member.payslips" */ '@/pages/[organisation]/portals/team-members/payslips/[id].vue'),
                name: 'team-member-portal.view-payslip',
                meta: {
                    guestRequired: false,
                    loginRequired: true,
                    permission: '*',
                },
            },
        ],
    },
];
